import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Card, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, Button } from "@mui/material";
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
import personOutline from "@iconify/icons-eva/person-outline";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Confirm from "src/components/common/ConfirmDialog";
import TopupDialog from "src/components/dialogs/TopupDialog";
import PointTopupDialog from "src/components/dialogs/PointTopupDialog";
import UserChargeDialog from "src/components/dialogs/UserChargeDialog";
import UIAvatar from "src/components/common/UIAvatar";
import { asyncRequest } from "src/services/network";
import SharesDialog from "src/components/dialogs/SharesDialog";
import UserInfo from "src/components/common/UserInfo";
import PointReleaseDialog from "src/components/dialogs/PointReleaseDialog";
import SalaryDialog from "src/components/dialogs/SalaryDialog";
import TitleDialog from "src/components/dialogs/TitleDialog";
import TreeSelect from "src/components/lib/tree-select/TreeSelect";
import StaffAddDialog from "src/components/dialogs/StaffAddDialog";
import MerchantActivityAddDialog from "src/components/dialogs/MerchantActivityAddDialog";
import MerchantInfo from "src/components/common/MerchantInfo";

const TABLE_HEAD = [
  { id: "mid", label: "商户", alignRight: false }, 
  { id: "total", label: "活动总金额", alignRight: false }, 
  { id: "remaining", label: "剩余金额", alignRight: false }, 
  { id: "threshold", label: "最大红包", alignRight: false }, 
  { id: "users", label: "参与用户数", alignRight: false }, 
  { id: "status", label: "是否开启", alignRight: false }, 
  { id: "createdAt", label: "开始时间", alignRight: false }, { id: "" }];

const moreMenus = [
  // { title: "编辑", icon: personOutline },
  // { title: "终止", icon: personOutline },
];

export default function MerchantActivity() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [targetUser, setTargetUser] = useState({});
  const [action, setAction] = useState("");

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/merchant/activity/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      setTargetUser(row);
      setAction("edit");
    } else if (type === "解除") {
      // handleDel(row);
    }
  };

  // function handleDel({ uid }) {
  //   Confirm({
  //     message: "确定解除商户活动职位吗?",
  //     async onConfirm() {
  //       await asyncRequest({
  //         path: "/user/staff/del",
  //         data: { uid },
  //       });

  //       getItems();
  //     },
  //   });
  // }

  function handleAddStaff() {
    setAction("add");
  }

  async function toggleEnabled(mid) {
    const { data } = await asyncRequest({
      path: "/merchant/activity/toggleEnabled",
      data: {
        mid,
      },
    });

    // const item = items.find((it) => it.mid == mid);
    // item.isEnabled = !item.isEnabled;
    // setItems([...items]);
    getItems();
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="商户活动列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            商户活动列表
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={() => handleAddStaff()}>
            添加商户
          </Button>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { mid, merchant, threshold, users, realname, total, remaining, createdAt, status } = row;
                    const isItemSelected = selected.indexOf(realname) !== -1;

                    return (
                      <TableRow hover key={mid} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        {/* <TableCell padding="checkbox">
                           <Checkbox
                             checked={isItemSelected}
                             onChange={(event) => handleClick(event, uid)}
                           />
                         </TableCell> */}
                        {/* <TableCell align="left">{uid}</TableCell> */}

                        <TableCell component="th" scope="row">
                          <MerchantInfo {...merchant} />
                        </TableCell>
                        <TableCell align="left">{total}</TableCell>
                        <TableCell align="left">{remaining}</TableCell>
                        <TableCell align="left">{threshold}</TableCell>
                        <TableCell align="left">{users}</TableCell>

                        <TableCell align="left">
                          <Switch checked={status === 1} onChange={() => toggleEnabled(mid)} />
                        </TableCell>

                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>

                        <TableCell align="right">
                          <MoreMenu spread={true} menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

      <MerchantActivityAddDialog
        action={action}
        open={action === "add" || action === "edit"}
        row={targetUser}
        onClose={() => setAction("")}
        onUpdate={() => {
          getItems();
          setAction("");
        }}
      />
    </Page>
  );
}
